import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";

export interface WarningState {
    isOpen: boolean;
    message?: any;
}
@Injectable({
    providedIn: 'root'
})
export class warningService {

    // constructor() {}
    private _isOpen = new BehaviorSubject<WarningState>({
        isOpen: false,
    });
    get isOpen() {
        return this._isOpen.asObservable();
    }

    private setIsOpen(state: WarningState) {
        this._isOpen.next(state);
    }

    public openWarningMsg(message: string, autoCloseDuration?: number) {
        this.setIsOpen({ isOpen: true, message });
        if (autoCloseDuration) {
            setTimeout(() => {
                this.close();
            }, autoCloseDuration);
        }
    }

    public close() {
        this.setIsOpen({ isOpen: false });
    }
}
